
// import React, { useState,useEffect } from "react";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import { useNavigate,useParams } from "react-router-dom";
// import Switch from "react-switch";
// import axios from "axios";
// import Footer from '../../components/Footer';
// import {toast, ToastContainer} from "react-toastify";

// const Memberdetail = () => {
//   const [status, setStatus] = useState("Pending");
//   const [renew, setRenew] = useState(false);
//   const[membership, setMembership] = useState([]);
//   const [data, setData] = useState(null);
//   const navigate = useNavigate();
//   const [planMember, setPlanMember] = useState("");
//  const {id} = useParams();

//   // const [editMode, setEditMode] = useState(false);
//   // const [editData, setEditData] = useState({
//   //   name: "",
//   //   mobileNo: "",
//   //   emailaddress: "",
//   //   profilePic: null,
//   //    address: "",
//   //   personalComment: "",
//   // });

//   // const [preview, setPreview] = useState(null);

//   useEffect(()=>{
//     fetchData();
//     fetchMembership();
//   },[])

  

//   const fetchMembership = async()=>{
// await axios.get(`${process.env.REACT_APP_FRONTEND_URL}/plans/get-membership`,{withCredentials:true}).then((response)=>{
//   setMembership(response.data.membership);
// setPlanMember(response.data.membership[0]._id);

//   // toast.success(response.data.message);
// }).catch(error=>{
//   toast.error("Membership load failed");
// })
//   }
//   const fetchData = async()=>{
// await axios.get(`${process.env.REACT_APP_FRONTEND_URL}/members/get-member/${id}`,{withCredentials:true}).then((response)=>{
//   console.log(response);
//   setData(response.data.member);
//   setStatus(response.data.member.status)
//   // toast.success(response.data.message);
// }).catch(error=>{
//   toast.error("Something Went Wrong");
// })
//   }

//   const handleSwitchBtn = async() => {
//     let statuss = status === "Active" ? "Pending" : "Active";
//     await axios.post(`${process.env.REACT_APP_FRONTEND_URL}/members/change-status/${id}`,{status:statuss}, {withCredentials:true}).then((response)=>{
// toast.success("Status Changed");

//     }).catch(error=>{
//   toast.error("Something Went Wrong");
// })
//     setStatus(statuss);
//   };


// const isDateInPast = (inputDate)=>{
//   const today = new Date();  // Get the current date
//   const givenDate = new Date(inputDate);  // Convert the input to a Date object

//   return givenDate < today;  // Check if the given date is before today
// };


// const handleOnChangeSelect = (event)=>{
// let value = event.target.value;
// setPlanMember(value);
// }

// const handleRenewSaveBtn = async()=>{
// await axios.put(`${process.env.REACT_APP_FRONTEND_URL}/members/update-member-plan/${id}`, {membership:planMember}, {withCredentials:true}).then((response)=>{
// setData(response.data.member);
// toast.success(response.data.message);
// }).catch(error=>{
//   toast.error("Something Went Wrong");
// })

// }

//   // ================= SET EDIT DATA =================
//   // useEffect(() => {
//   //   if (data && !editMode) {
//   //     setEditData({
//   //       name: data.name || "",
//   //       mobileNo: data.mobileNo || "",
//   //       emailaddress: data.emailaddress || "",
//   //       // profilePic: null,
//   //       address: data.address || "",
//   //       personalComment: data.personalComment || "",       
//   //     });
//   //     setPreview(null);
//   //   }
//   // }, [data, editMode]);

//     // ================= INPUT =================
//   // const handleInputChange = (e) => {
//   //   setEditData({ ...editData, [e.target.name]: e.target.value });
//   // };
//     // ================= FILE CHANGE + PREVIEW =================
//   // const handleFileChange = (e) => {
//   //   const file = e.target.files[0];

//   //   setEditData((prev) => ({
//   //     ...prev,
//   //     profilePic: file,
//   //   }));

//   //   setPreview(URL.createObjectURL(file));
//   // };
//     // ================= SAVE EDIT =================
//   // const handleEditSave = async () => {
//   //   try {
//   //     const formData = new FormData();
//   //     formData.append("name", editData.name);
//   //     formData.append("mobileNo", editData.mobileNo);
//   //     formData.append("emailaddress", editData.emailaddress);

//   //      if (editData.profilePic) {
//   //        formData.append("profilePic", editData.profilePic);
//   //      }
//   //      formData.append("address", editData.address);
//   //       formData.append("personalComment", editData.personalComment);     

//   //     const res = await axios.put(
//   //       `${process.env.REACT_APP_FRONTEND_URL}/members/update-member/${id}`,
//   //       formData,
//   //       { withCredentials: true }
//   //     );

//   //     setData(res.data.member);
//   //     setEditMode(false);
//   //     toast.success("Updated Successfully");
//   //   } catch {
//   //     toast.error("Update Failed");
//   //   }
//   // };
// //  const formatDate = (date) =>
// //     date ? date.slice(0, 10).split("-").reverse().join("-") : "N/A";


//   return (
//     <div className="dashboard-box">
//       <div
//         onClick={() => {
//           navigate(-1);
//         }}
//         className=" dashbacklink goback "
//       >
//         <ArrowBackIcon /> Go Back
//       </div>
//       <div className="dashboard-box projects__container container grid ">
//         <div className="projects__card memberdatailImg">
//           <img src={data?.profilePic} />
//         </div>

//         <div className="projects__card memberdetailImgdetail ">
//           <div>
//             <h2 className="projects__title">Name : {data?.name}</h2>
//             <h2 className="projects__title"> Mobile : {data?.mobileNo} </h2>
//             <h2 className="projects__title">Email : {data?.emailaddress}</h2>
//             <h2 className="projects__title">Address : {data?.address}</h2>
//             <h2 className="projects__title">Joined Date : {data?.createdAt.slice(0,10).split("-").reverse().join("-")}</h2>
//             <h2 className="projects__title">Next Bill Date : {data?.nextBillDate.slice(0,10).split("-").reverse().join("-")}</h2>
//             <h2 className="projects__title">
//               Status :{" "}
//               <Switch
//                 checked={status === "Active"}
//                 onChange={() => {
//                   handleSwitchBtn();
//                 }}
//               />{" "}
//             </h2>

//             <h2 className="projects__title">Personal Comment : {data?.personalComment}</h2>

//             {
//             isDateInPast(data?.nextBillDate)&&<div
//               onClick={() => {
//                 setRenew((prev) => !prev);
//               }}
//               className="contact__button button renew"
//             >
//               Renew
//             </div>
//             }



//             {renew && status === "Active" ? (
//               <div className=" memberdatailImg memberDetailMembership">
//                 <h2 className="projects__title">Membership</h2>
//                 <select value={planMember} onChange={handleOnChangeSelect} className="addmembers1In">
//              {
//               membership.map((item, index)=>{
//                 return(
//                        <option value={item._id}>{item.months} Month membership</option>
//                 );
//               })
//              }
//                 </select>

//                 <div onClick={()=>{handleRenewSaveBtn()}} className="contact__button button renew">Save</div>
//               </div>
//             ) : null}
//           </div>
//         </div>
//       </div>
//       <Footer />
//       <ToastContainer/>
//     </div>
//   );
// };

// export default Memberdetail;



import React, { useState, useEffect } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate, useParams } from "react-router-dom";
import Switch from "react-switch";
import axios from "axios";
import Footer from "../../components/Footer";
import { toast, ToastContainer } from "react-toastify";

const Memberdetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [data, setData] = useState(null);
  const [status, setStatus] = useState("Pending");
  const [editMode, setEditMode] = useState(false);
  const [renew, setRenew] = useState(false);

  const [membership, setMembership] = useState([]);
  const [planMember, setPlanMember] = useState("");
  const [loaderImage, setLoaderImage] = useState(false);

  const [editData, setEditData] = useState({
    name: "",
    mobileNo: "",
    emailaddress: "",
    profilePic: null,
    address: "",
    personalComment: "",
  });

  const [preview, setPreview] = useState(null);

  // ================= FETCH DATA =================
  useEffect(() => {
    fetchData();
    fetchMembership();
  }, []);

  const fetchData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_FRONTEND_URL}/members/get-member/${id}`,       
        { withCredentials: true }
      );

      setData(res.data.member);
      setStatus(res.data.member.status);
    } catch {
      toast.error("Failed to load member");
    }
  };

  const fetchMembership = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_FRONTEND_URL}/plans/get-membership`,
        { withCredentials: true }
      );

      setMembership(res.data.membership || []);

      if (res.data.membership?.length > 0) {
        setPlanMember(res.data.membership[0]._id);
      }
    } catch {
      toast.error("Membership load failed");
    }
  };

  // ================= SET EDIT DATA =================
  useEffect(() => {
    if (data && !editMode) {
      setEditData({
        name: data.name || "",
        mobileNo: data.mobileNo || "",
        emailaddress: data.emailaddress || "",

        profilePic: null,
       address: data.address || "",
        personalComment: data.personalComment || "",
      });
      setPreview(null);
    }
  }, [data, editMode]);

  // ================= INPUT =================
  const handleInputChange = (e) => {
    setEditData({ ...editData, [e.target.name]: e.target.value });
  };

  // ================= FILE CHANGE + PREVIEW =================
  // const handleFileChange = (e) => {
  //   const file = e.target.files[0];

  //   setEditData((prev) => ({
  //     ...prev,
  //     profilePic: file,
  //   }));

  //   setPreview(URL.createObjectURL(file));
  // };

const handleFileChange = async (e) => {
   setLoaderImage(true);
  const files = e.target.files;

  if (!files || files.length === 0) return;

  const data = new FormData();
  data.append('file', files[0]);
  data.append('upload_preset', 'trego.in');

  try {
    const response = await axios.post(
      "https://api.cloudinary.com/v1_1/dvawsdzao/image/upload",
      data,
      {
        withCredentials: false
      }
    );

    const imageUrl = response.data.secure_url;

    setEditData((prev) => ({
      ...prev,
      profilePic: imageUrl
    }));

     setPreview(imageUrl);
setLoaderImage(false);
  } catch (err) {
    setLoaderImage(false);
    console.log("Upload Error:", err);
  }
};

  // ================= SAVE EDIT =================
  // const handleEditSave = async () => {
  //   try {
  //     const formData = new FormData();
  //     formData.append("name", editData.name);
  //     formData.append("mobileNo", editData.mobileNo);
  //     formData.append("emailaddress", editData.emailaddress);

  //     if (editData.profilePic) {
  //       formData.append("profilePic", editData.profilePic);
  //     }

  //     formData.append("address", editData.address);
  //      formData.append("personalComment", editData.personalComment);

  //     const res = await axios.put(
  //       `${process.env.REACT_APP_FRONTEND_URL}/members/update-member/${id}`,
  //       formData,
  //       { withCredentials: true }
  //     );

  //     setData(res.data.member);
  //     setEditMode(false);
  //     toast.success("Updated Successfully");
  //   } catch {
  //     toast.error("Update Failed");
  //   }
  // };

    const handleEditSave = async () => {
  try {
    const payload = {
      name: editData.name,
      mobileNo: editData.mobileNo,
      emailaddress: editData.emailaddress,
      address: editData.address,
      personalComment: editData.personalComment,
      profilePic: editData.profilePic, // ✅ cloudinary URL
    };

    const res = await axios.put(
      `${process.env.REACT_APP_FRONTEND_URL}/members/update-member/${id}`,
      payload,
      { withCredentials: true }
    );

    setData(res.data.member);
    setEditMode(false);
    toast.success("Updated Successfully");

  } catch {
    toast.error("Update Failed");
  }
};

  // ================= STATUS =================
  const handleSwitchBtn = async () => {
    try {
      const newStatus = status === "Active" ? "Pending" : "Active";

      await axios.post(
        `${process.env.REACT_APP_FRONTEND_URL}/members/change-status/${id}`,
        { status: newStatus },
        { withCredentials: true }
      );

      setStatus(newStatus);
    } catch {
      toast.error("Status Failed");
    }
  };

  // ================= RENEW =================
  const handleRenewSaveBtn = async () => {
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_FRONTEND_URL}/members/update-member-plan/${id}`,
        { membership: planMember },
        { withCredentials: true }
      );

      setData(res.data.member);
      setRenew(false);
      toast.success("Plan Updated");
    } catch {
      toast.error("Renew Failed");
    }
  };

  // ================= HELPERS =================
  // const isDateInPast = (date) => {
  //   if (!date) return false;
  //   return (
  //     new Date(date).setHours(0, 0, 0, 0) <
  //     new Date().setHours(0, 0, 0, 0)
  //   );
  // };

const isWithin7Days = (date) => {
  if (!date) return false;

  const today = new Date();
  const expiry = new Date(date);

  // 7 days future date
  const sevenDaysBefore = new Date(expiry);
  sevenDaysBefore.setDate(expiry.getDate() - 7);

  return today >= sevenDaysBefore;
};

  const formatDate = (date) =>
    date ? date.slice(0, 10).split("-").reverse().join("-") : "N/A";


  const handleDelete = async () => {
  if (!window.confirm("Are you sure you want to delete this member?")) return;

  try {
    await axios.delete(
      `${process.env.REACT_APP_FRONTEND_URL}/members/delete-member/${id}`,
      { withCredentials: true }
    );

    toast.success("Member Deleted");

    navigate("/member"); 
  } catch {
    toast.error("Delete Failed");
  }
};

  return (
    <div className="dashboard-box">

      <div onClick={() => navigate(-1)} className="dashbacklink goback">
        <ArrowBackIcon /> Go Back
      </div>

      <div className="dashboard-box projects__container container grid">

        {/* IMAGE */}
        <div className="projects__card memberdatailImg">
          <img
            src={preview || data?.profilePic || "/default.png"}
            alt="profile"
          />

          {editMode && (
            <>
              <input type="file" onChange={handleFileChange} />
              {/* {editData.profilePic && <p>Image Selected ✓</p>} */}
              {loaderImage ? (
                <div className="loader"></div>
                 ):(
        // <p>Image Selected ✓</p>
        preview && <p>Image Selected ✓</p>
                 )}
            
              {/* {preview && <p>Image Selected ✓</p>} */}
            </>
          )}
        </div>

        {/* DETAILS */}
        <div className="projects__card memberdetailImgdetail">
          <div>

            {/* NAME */}
            {editMode ? (
              <input
                name="name"
                value={editData.name}
                onChange={handleInputChange}
                className="addmembers1In"
              />
            ) : (
              <h2>Name : {data?.name}</h2>
            )}

            {/* MOBILE */}
            {editMode ? (
              <input
                name="mobileNo"
                value={editData.mobileNo}
                onChange={handleInputChange}
                className="addmembers1In"
              />
            ) : (
              <h2>Mobile : <a href={`tel:+91${data?.mobileNo}`}  style={{ color: "inherit", textDecoration: "none" }} >
            +91 {data?.mobileNo}
          </a> </h2>

              // <h2>Mobile : {data?.mobileNo}</h2>
            )}

            {/* EMAIL */}
            {editMode ? (
              <input
                name="emailaddress"
                value={editData.emailaddress}
                onChange={handleInputChange}
                className="addmembers1In"
              />
            ) : (
              <h2>Email : <a href={`mailto:${data?.emailaddress}`}  style={{ color: "inherit", textDecoration: "none" }} >
             {data?.emailaddress}
          </a> </h2>
              // <h2>Email : {data?.emailaddress}</h2>
            )}

            {/* Address */}
            {editMode ? (
              <input
                name="address"
                value={editData.address}
                onChange={handleInputChange}
                className="addmembers1In"
              />
            ) : (
              <h2>Address : {data?.address}</h2>
            )}



            {/* <h2>Address : {data?.address}</h2> */}
            <h2>Joined : {formatDate(data?.createdAt)}</h2>
            <h2>Next Bill : {formatDate(data?.nextBillDate)}</h2>

            {/* STATUS */}
            <h2>
              Status :
              <Switch
                checked={status === "Active"}
                onChange={handleSwitchBtn}
              />
            </h2>

            {/* PARSIONAL COMMENT */}

            {editMode ? (
              <input
                name="personalComment"
                value={editData.personalComment}
                onChange={handleInputChange}
                className="addmembers1In"
              />
            ) : (
              <h2>Personal Comment : {data?.personalComment}</h2>
            )}
    
        <br />

                     {/* Whatsupp */}
<div style={{ textAlign: "center" }}>
 <a href={`https://wa.me/91${data?.mobileNo}`} style={{ color: "green", textDecoration: "none", fontSize: "50px" }} target="_blank" rel="noreferrer" > <i class="ri-whatsapp-line"></i> </a>
</div>
<br></br>

            {/* EDIT BUTTON */}
            {editMode ? (
              <div onClick={handleEditSave} className="btn blue">
                Save
              </div>
            ) : (
              <div
                onClick={() => setEditMode(true)}
                className="btn blue"
              >
                Edit
              </div>
            )}

       <br />
           {/* Member Delete button */}
            <div onClick={handleDelete}
             className="btn blue"  
             >
                   Delete
                  </div>
       <br />         

            {/* RENEW */}
            {/* {isDateInPast(data?.nextBillDate) && (
              <div
                onClick={() => setRenew(!renew)}
                className="btn blue"
              >
                Renew
              </div>
            )} */}


          {/* RENEW (Active only) */}
          {status === "Active" &&
            isWithin7Days(data?.nextBillDate) && (
              <div
                onClick={() => setRenew(true)}
                className="btn blue"
              >
                Renew
              </div>
            )}

          {/* CONTINUE (Pending / Expired) */}
          {status !== "Active" && (
            <div
              onClick={() => setRenew(true)}
              className="btn blue"
            >
              Continue
            </div>
          )}

            {renew && (
              <div className="memberDetailMembership">

                <h2>Monthly Membership</h2>

                <select
                  value={planMember}
                  onChange={(e) => setPlanMember(e.target.value)}
                >
                  {membership.map((item) => (
                    <option key={item._id} value={item._id}>
                      {item.months} Month
                    </option>
                  ))}
                </select>

                <div
                  onClick={handleRenewSaveBtn}
                  className="btn blue"
                >
                  Save
                </div>
              </div>
            )}

          </div>
        </div>
      </div>

      <Footer />
      <ToastContainer />
    </div>
  );
};

export default Memberdetail;



// import React, { useState, useEffect } from "react";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import { useNavigate, useParams } from "react-router-dom";
// import Switch from "react-switch";
// import axios from "axios";
// import Footer from "../../components/Footer";
// import { toast, ToastContainer } from "react-toastify";

// const Memberdetail = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();

//   const [data, setData] = useState(null);
//   const [status, setStatus] = useState("Pending");
//   const [editMode, setEditMode] = useState(false);
//   const [renew, setRenew] = useState(false);

//   const [membership, setMembership] = useState([]);
//   const [planMember, setPlanMember] = useState("");

//   const [editData, setEditData] = useState({
//     name: "",
//     mobileNo: "",
//     emailaddress: "",
//     profilePic: null,
//   });

//   const [preview, setPreview] = useState(null);

//   // ================= FETCH DATA =================
//   useEffect(() => {
//     fetchData();
//     fetchMembership();
//   }, []);

//   const fetchData = async () => {
//     try {
//       const res = await axios.get(
//         `http://localhost:4000/members/get-member/${id}`,
//         { withCredentials: true }
//       );

//       setData(res.data.member);
//       setStatus(res.data.member.status);
//     } catch {
//       toast.error("Failed to load member");
//     }
//   };

//   const fetchMembership = async () => {
//     try {
//       const res = await axios.get(
//         "http://localhost:4000/plans/get-membership",
//         { withCredentials: true }
//       );

//       setMembership(res.data.membership || []);

//       if (res.data.membership?.length > 0) {
//         setPlanMember(res.data.membership[0]._id);
//       }
//     } catch {
//       toast.error("Membership load failed");
//     }
//   };

//   // ================= SET EDIT DATA =================
//   useEffect(() => {
//     if (data && !editMode) {
//       setEditData({
//         name: data.name || "",
//         mobileNo: data.mobileNo || "",
//         emailaddress: data.emailaddress || "",
//         profilePic: null,
//       });
//       setPreview(null);
//     }
//   }, [data, editMode]);

//   // ================= INPUT =================
//   const handleInputChange = (e) => {
//     setEditData({ ...editData, [e.target.name]: e.target.value });
//   };

//   // ================= FILE CHANGE + PREVIEW =================
//   const handleFileChange = (e) => {
//     const file = e.target.files[0];

//     setEditData((prev) => ({
//       ...prev,
//       profilePic: file,
//     }));

//     setPreview(URL.createObjectURL(file));
//   };

//   // ================= SAVE EDIT =================
//   const handleEditSave = async () => {
//     try {
//       const formData = new FormData();
//       formData.append("name", editData.name);
//       formData.append("mobileNo", editData.mobileNo);
//       formData.append("emailaddress", editData.emailaddress);

//       if (editData.profilePic) {
//         formData.append("profilePic", editData.profilePic);
//       }

//       const res = await axios.put(
//         `http://localhost:4000/members/update-member/${id}`,
//         formData,
//         { withCredentials: true }
//       );

//       setData(res.data.member);
//       setEditMode(false);
//       toast.success("Updated Successfully");
//     } catch {
//       toast.error("Update Failed");
//     }
//   };

//   // ================= STATUS =================
//   const handleSwitchBtn = async () => {
//     try {
//       const newStatus = status === "Active" ? "Pending" : "Active";

//       await axios.post(
//         `http://localhost:4000/members/change-status/${id}`,
//         { status: newStatus },
//         { withCredentials: true }
//       );

//       setStatus(newStatus);
//     } catch {
//       toast.error("Status Failed");
//     }
//   };

//   // ================= RENEW =================
//   const handleRenewSaveBtn = async () => {
//     try {
//       const res = await axios.put(
//         `http://localhost:4000/members/update-member-plan/${id}`,
//         { membership: planMember },
//         { withCredentials: true }
//       );

//       setData(res.data.member);
//       setRenew(false);
//       toast.success("Plan Updated");
//     } catch {
//       toast.error("Renew Failed");
//     }
//   };

//   // ================= HELPERS =================
//   const isDateInPast = (date) => {
//     if (!date) return false;
//     return (
//       new Date(date).setHours(0, 0, 0, 0) <
//       new Date().setHours(0, 0, 0, 0)
//     );
//   };

//   const formatDate = (date) =>
//     date ? date.slice(0, 10).split("-").reverse().join("-") : "N/A";

//   return (
//     <div className="dashboard-box">

//       <div onClick={() => navigate(-1)} className="dashbacklink goback">
//         <ArrowBackIcon /> Go Back
//       </div>

//       <div className="dashboard-box projects__container container grid">

//         {/* IMAGE */}
//         <div className="projects__card memberdatailImg">
//           <img
//             src={preview || data?.profilePic || "/default.png"}
//             alt="profile"
//           />

//           {editMode && (
//             <>
//               <input type="file" onChange={handleFileChange} />
//               {editData.profilePic && <p>Image Selected ✓</p>}
//             </>
//           )}
//         </div>

//         {/* DETAILS */}
//         <div className="projects__card memberdetailImgdetail">
//           <div>

//             {/* NAME */}
//             {editMode ? (
//               <input
//                 name="name"
//                 value={editData.name}
//                 onChange={handleInputChange}
//                 className="addmembers1In"
//               />
//             ) : (
//               <h2>Name : {data?.name}</h2>
//             )}

//             {/* MOBILE */}
//             {editMode ? (
//               <input
//                 name="mobileNo"
//                 value={editData.mobileNo}
//                 onChange={handleInputChange}
//                 className="addmembers1In"
//               />
//             ) : (
//               <h2>Mobile : {data?.mobileNo}</h2>
//             )}

//             {/* EMAIL */}
//             {editMode ? (
//               <input
//                 name="emailaddress"
//                 value={editData.emailaddress}
//                 onChange={handleInputChange}
//                 className="addmembers1In"
//               />
//             ) : (
//               <h2>Email : {data?.emailaddress}</h2>
//             )}

//             <h2>Address : {data?.address}</h2>
//             <h2>Joined : {formatDate(data?.createdAt)}</h2>
//             <h2>Next Bill : {formatDate(data?.nextBillDate)}</h2>

//             {/* STATUS */}
//             <h2>
//               Status :
//               <Switch
//                 checked={status === "Active"}
//                 onChange={handleSwitchBtn}
//               />
//             </h2>

//             {/* EDIT BUTTON */}
//             {editMode ? (
//               <div onClick={handleEditSave} className="btn blue">
//                 Save
//               </div>
//             ) : (
//               <div
//                 onClick={() => setEditMode(true)}
//                 className="contact__button button"
//               >
//                 Edit
//               </div>
//             )}

//             {/* RENEW */}
//             {isDateInPast(data?.nextBillDate) && (
//               <div
//                 onClick={() => setRenew(!renew)}
//                 className="contact__button button renew"
//               >
//                 Renew
//               </div>
//             )}

//             {renew && status === "Active" && (
//               <div className="memberDetailMembership">

//                 <h2>Membership</h2>

//                 <select
//                   value={planMember}
//                   onChange={(e) => setPlanMember(e.target.value)}
//                 >
//                   {membership.map((item) => (
//                     <option key={item._id} value={item._id}>
//                       {item.months} Month
//                     </option>
//                   ))}
//                 </select>

//                 <div
//                   onClick={handleRenewSaveBtn}
//                   className="contact__button button renew"
//                 >
//                   Save
//                 </div>
//               </div>
//             )}

//           </div>
//         </div>
//       </div>

//       <Footer />
//       <ToastContainer />
//     </div>
//   );
// };

// export default Memberdetail;



// import React, { useState,useEffect } from "react";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import { useNavigate,useParams } from "react-router-dom";
// import Switch from "react-switch";
// import axios from "axios";
// import Footer from '../../components/Footer';
// import {toast, ToastContainer} from "react-toastify";

// const Memberdetail = () => {
//   const [status, setStatus] = useState("Pending");
//   const [renew, setRenew] = useState(false);
//   const[membership, setMembership] = useState([]);
//   const [data, setData] = useState(null);
//   const navigate = useNavigate();
//   const [planMember, setPlanMember] = useState("");
//  const {id} = useParams();

//   // const [editMode, setEditMode] = useState(false);
//   // const [editData, setEditData] = useState({
//   //   name: "",
//   //   mobileNo: "",
//   //   emailaddress: "",
//   //   profilePic: null,
//   // });

//   // const [preview, setPreview] = useState(null);

//   useEffect(()=>{
//     fetchData();
//     fetchMembership();
//   },[])

  

//   const fetchMembership = async()=>{
// await axios.get(`${process.env.REACT_APP_FRONTEND_URL}/plans/get-membership`,{withCredentials:true}).then((response)=>{
//   setMembership(response.data.membership);
// setPlanMember(response.data.membership[0]._id);

//   // toast.success(response.data.message);
// }).catch(error=>{
//   toast.error("Something Went Wrong");
// })
//   }
//   const fetchData = async()=>{
// await axios.get(`${process.env.REACT_APP_FRONTEND_URL}/members/get-member/${id}`,{withCredentials:true}).then((response)=>{
//   console.log(response);
//   setData(response.data.member);
//   setStatus(response.data.member.status)
//   // toast.success(response.data.message);
// }).catch(error=>{
//   toast.error("Something Went Wrong");
// })
//   }

//   const handleSwitchBtn = async() => {
//     let statuss = status === "Active" ? "Pending" : "Active";
//     await axios.post(`${process.env.REACT_APP_FRONTEND_URL}/members/change-status/${id}`,{status:statuss}, {withCredentials:true}).then((response)=>{
// toast.success("Status Changed");

//     }).catch(error=>{
//   toast.error("Something Went Wrong");
// })
//     setStatus(statuss);
//   };


// const isDateInPast = (inputDate)=>{
//   const today = new Date();  // Get the current date
//   const givenDate = new Date(inputDate);  // Convert the input to a Date object

//   return givenDate < today;  // Check if the given date is before today
// };


// const handleOnChangeSelect = (event)=>{
// let value = event.target.value;
// setPlanMember(value);
// }

// const handleRenewSaveBtn = async()=>{
// await axios.put(`${process.env.REACT_APP_FRONTEND_URL}/members/update-member-plan/${id}`, {membership:planMember}, {withCredentials:true}).then((response)=>{
// setData(response.data.member);
// toast.success(response.data.message);
// }).catch(error=>{
//   toast.error("Something Went Wrong");
// })

// }

//   // ================= SET EDIT DATA =================
//   // useEffect(() => {
//   //   if (data && !editMode) {
//   //     setEditData({
//   //       name: data.name || "",
//   //       mobileNo: data.mobileNo || "",
//   //       emailaddress: data.emailaddress || "",
//   //       profilePic: null,
//   //     });
//   //     setPreview(null);
//   //   }
//   // }, [data, editMode]);

//     // ================= INPUT =================
//   // const handleInputChange = (e) => {
//   //   setEditData({ ...editData, [e.target.name]: e.target.value });
//   // };
//     // ================= FILE CHANGE + PREVIEW =================
//   // const handleFileChange = (e) => {
//   //   const file = e.target.files[0];

//   //   setEditData((prev) => ({
//   //     ...prev,
//   //     profilePic: file,
//   //   }));

//   //   setPreview(URL.createObjectURL(file));
//   // };
//     // ================= SAVE EDIT =================
//   // const handleEditSave = async () => {
//   //   try {
//   //     const formData = new FormData();
//   //     formData.append("name", editData.name);
//   //     formData.append("mobileNo", editData.mobileNo);
//   //     formData.append("emailaddress", editData.emailaddress);

//   //     if (editData.profilePic) {
//   //       formData.append("profilePic", editData.profilePic);
//   //     }

//   //     const res = await axios.put(
//   //       `${process.env.REACT_APP_FRONTEND_URL}/members/update-member/${id}`,
//   //       formData,
//   //       { withCredentials: true }
//   //     );

//   //     setData(res.data.member);
//   //     setEditMode(false);
//   //     toast.success("Updated Successfully");
//   //   } catch {
//   //     toast.error("Update Failed");
//   //   }
//   // };
// //  const formatDate = (date) =>
// //     date ? date.slice(0, 10).split("-").reverse().join("-") : "N/A";


//   return (
//     <div className="dashboard-box">
//       <div
//         onClick={() => {
//           navigate(-1);
//         }}
//         className=" dashbacklink goback "
//       >
//         <ArrowBackIcon /> Go Back
//       </div>
//       <div className="dashboard-box projects__container container grid ">
//         <div className="projects__card memberdatailImg">
//           <img src={data?.profilePic} />
//         </div>

//         <div className="projects__card memberdetailImgdetail ">
//           <div>
//             <h2 className="projects__title">Name : {data?.name}</h2>
//             <h2 className="projects__title"> Mobile : {data?.mobileNo} </h2>
//             <h2 className="projects__title">Email : {data?.emailaddress}</h2>
//             <h2 className="projects__title">Address : {data?.address}</h2>
//             <h2 className="projects__title">Joined Date : {data?.createdAt.slice(0,10).split("-").reverse().join("-")}</h2>
//             <h2 className="projects__title">Next Bill Date : {data?.nextBillDate.slice(0,10).split("-").reverse().join("-")}</h2>
//             <h2 className="projects__title">
//               Status :{" "}
//               <Switch
//                 checked={status === "Active"}
//                 onChange={() => {
//                   handleSwitchBtn();
//                 }}
//               />{" "}
//             </h2>

//             {
//             isDateInPast(data?.nextBillDate)&&<div
//               onClick={() => {
//                 setRenew((prev) => !prev);
//               }}
//               className="contact__button button renew"
//             >
//               Renew
//             </div>
//             }



//             {renew && status === "Active" ? (
//               <div className=" memberdatailImg memberDetailMembership">
//                 <h2 className="projects__title">Membership</h2>
//                 <select value={planMember} onChange={handleOnChangeSelect} className="addmembers1In">
//              {
//               membership.map((item, index)=>{
//                 return(
//                        <option value={item._id}>{item.months} Month membership</option>
//                 );
//               })
//              }
//                 </select>

//                 <div onClick={()=>{handleRenewSaveBtn()}} className="contact__button button renew">Save</div>
//               </div>
//             ) : null}
//           </div>
//         </div>
//       </div>
//       <Footer />
//       <ToastContainer/>
//     </div>
//   );
// };

// export default Memberdetail;